module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAsQAAALEBxi1JjQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAEnSURBVEiJ7ZI7SwNREEbPZDfGbBYVCwUfSEiRwkLUMq2lpf/B1tYfYWURtPYvaG+RUtDCwFYiBAvJo9no3fUxFmFD1Khkdy2UnGoYLt9hZi6M+fdIVFw7a0eCbqYRqsjF6sPVLoDdN4mWUd4JprenCBshj5dmJIGI+lGdGfYg4/Ta1owFKgNzjs4ngdjC0uECkhXaJx2MZ1iuLjJZziUXuJUCpbMizkae0mkRt1JAjdI6bhM2npIL/FoX4/X2bTyDX+siFiCggSYXAJh6QGPvDlMPAJBchvn9OaxZK5bA/thoVlsA+OddnPU8z50XbnZuY4XDF78owt1ymVjJxg6HIRMMcn/QhNd4u4/4doKk4T8LUuDXBf0bqIonqJtGqKp4aeSM+SO8ATbDU1DxA7RWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./images/china_icon.png
// module id = 141
// module chunks = 0